import type { ModuleKey } from '../../../../shell/session/store/sessionTypes';
import type { BusinessCapability } from '../../../../shell/session/domain/businessProfile';
import {
  ROLE_PRESETS,
  LEGACY_MANAGER_PRESET_ID,
  ROLE_LABELS_ES,
  resolvePresetId,
  findRolePreset,
  invitationRoleLabel,
  resolvePresetPermissions,
  presetToApiPayload,
  presetPermissionsForModules,
  filterPresetsByCapabilities as filterPresetsByCapabilitiesShared,
  type RolePreset,
  type PresetPermissions,
} from '@shared/employeePermissions';

export type { PresetPermissions, RolePreset };

export {
  ROLE_PRESETS,
  LEGACY_MANAGER_PRESET_ID,
  ROLE_LABELS_ES,
  resolvePresetId,
  findRolePreset,
  invitationRoleLabel,
  resolvePresetPermissions,
  presetToApiPayload,
  presetPermissionsForModules,
};

/** Filtra presets por capability del rubro (tipado negocio). */
export function filterPresetsByCapabilities(
  presets: RolePreset[],
  capabilities: Set<BusinessCapability>
): RolePreset[] {
  return filterPresetsByCapabilitiesShared(presets, capabilities as Set<string>);
}
